/**
 * Here there are the javascript utils for handlebars
 *
 * @author: David Pocina <dpocina[at]zerogrey[dot]com>
 *
 */

/* globals window */

(function ($, _) {
  'use strict'

  // Establish the root object ('window' in the browser)
  const root = this

  // HANDLEBARS RENDERER
  // ===================

  const handlebarsTemplates = {
    // used to cache the compiled templates
    compiled: $.extend({}, Handlebars.templates || {}),

    getTemplate(id) {
      return String($('#template-' + id).html()).trim() || 'Missing Template: ' + id
    },

    registerPartial(id) {
      Handlebars.registerPartial(id, this.compiled[id] || this.getTemplate(id))
    },

    render(type, data) {
      let result = null

      if (!type) {
        throw new Error('handlebars-renderer.js - called with undefined template')
      }

      if (root.DEBUG) {
        result = '<div class="alert alert-danger">' +
						'<strong>HANDLEBARS Compilation Runtime Not Available:</strong><br>' +
						'Please provide a pre-compiled template for ' + type +
						'</div>'
      }

      if (!this.compiled[type] && Handlebars.compile) {
        this.compiled[type] = Handlebars.compile(this.getTemplate(type))
      }

      if (_.isFunction(this.compiled[type])) {
        result = this.compiled[type](data)
      }

      return result
    }
  }

  root.handlebarsTemplates = handlebarsTemplates

  // HANDLEBARS HELPERS
  // ==================

  /**
	 *
	 */
  Handlebars.registerHelper('calculate', function (lvalue, operator, rvalue, options) {
    let result
    const operators = {
      '+'(l, r) {
        return (Number(l)) + (Number(r))
      },
      '-'(l, r) {
        return (Number(l)) - (Number(r))
      },
      '*'(l, r) {
        return (Number(l)) * (Number(r))
      },
      '/'(l, r) {
        return (Number(l)) / (Number(r))
      },
      '%'(l, r) {
        return (Number(l)) % (Number(r))
      }
    }

    if (!operators[operator]) {
      throw new Error('Handlebars Helper "calculate": undefined operator ' + operator)
    }

    result = operators[operator](lvalue, rvalue)

    if (options && options.fn) {
      result = result !== null ? options.fn(this) : options.inverse(this)
    }

    return result
  })

  /**
	 *
	 */
  Handlebars.registerHelper('generateCmsStickers', (pid, categories, promotions, options) => {
    const categoryKeys = _.keys(categories)
    const promotionKeys = (promotions && promotions.applied) ? _.keys(promotions.applied) : []
    let isProduct = false
    let isAssignedToPromotion = false
    let isAssignedToCategories = false

    if (!window.CMS_STICKERS) {
      return options.inverse()
    }

    return _.reduce(window.CMS_STICKERS, (buffer, element) => {
      // pid has to be a string
      isProduct = _.contains(element.products, String(pid))
      isAssignedToCategories = _.intersection(categoryKeys, element.categories).length
      isAssignedToPromotion = Boolean(_.intersection(promotionKeys, element.promotions).length)

      return (isProduct || isAssignedToCategories || isAssignedToPromotion) ?
        buffer + options.fn(element) :
        buffer
    }, '')
  })

  /**
	 *
	 */
  Handlebars.registerHelper('compare', function (lvalue, operator, rvalue, options) {
    let result
    const operators = {
      '&&'(l, r) {
        return l && r
      },
      '||'(l, r) {
        return l || r
      },
      '=='(l, r) {
        return l == r
      },
      '==='(l, r) {
        return l === r
      },
      '!='(l, r) {
        return l != r
      },
      '!=='(l, r) {
        return l !== r
      },
      '<'(l, r) {
        return l < r
      },
      '>'(l, r) {
        return l > r
      },
      '<='(l, r) {
        return l <= r
      },
      '>='(l, r) {
        return l >= r
      },
      typeof(l, r) {
        return typeof l === r
      }
    }

    if (!operators[operator]) {
      throw new Error('Handlebars Helper "compare": undefined operator ' + operator)
    }

    result = operators[operator](lvalue, rvalue)

    if (options && options.fn) {
      result = result ? options.fn(this) : options.inverse(this)
    }

    return result
  })

  /**
	 * Replace url http with https
	 *
	 */
  Handlebars.registerHelper('convertToHttps', url => {
    return url.replace('http://', 'https://')
  })

  /**
	 *
	 */
  Handlebars.registerHelper('count', function (variable, options) {
    let prop; let
      result = 0

    if (_.isArray(variable)) {
      result = variable.length
    } else if (_.isObject(variable)) {
      for (prop in variable) {
        if (variable.hasOwnProperty(prop)) {
          result++
        }
      }
    } else if (!_.isNull(variable) && !_.isUndefined(variable)) {
      result = 1
    }

    if (options && options.fn) {
      result = result ? options.fn(result) : options.inverse(this)
    }

    return result
  })

  /**
	 * Prints information about the current variable / context to the console
	 *
	 */
  Handlebars.registerHelper('debug', function (value, options) {
    if (root.DEBUG) { // only print debug info if the page is in DEBUG mode
      console.log('/ -------------')
      console.log('Context:', this)

      if (value && options) {
        console.log('----')
        console.log('Value:', value)
      }
    }
  })

  /**
	 *
	 */
  Handlebars.registerHelper('encodeURIComponent', component => {
    return encodeURIComponent(component)
  })

  /**
	 *
	 */
  Handlebars.registerHelper('getCurrentUrl', () => {
    return window.location.href
  })

  Handlebars.registerHelper('getCurrentUrlEncoded', () => {
    return encodeURIComponent(window.location.href)
  })

  /**
	 *
	 */
  Handlebars.registerHelper('getElement', function (context, item, options) {
    let result

    result = context && context[item] ? options.fn(context[item]) : options.inverse(this)

    return result
  })
  Handlebars.registerHelper('getStar', n => {
    let result = ''

    for (let i = 0; i < n; i++) {
      result += '<i class="fas fa-star" aria-hidden="true"></i>'
    }

    return new Handlebars.SafeString(result)
  })

  /**
	 * Get a js variable from the template.
	 *
	 * usage:
	 *     {{getJsVar "varName" }}
	 *     {{getJsVar "obj.path.to.var" }}
	 */
  Handlebars.registerHelper('getJsVar', function (variable, options) {
    let i
    const prop = variable.split('.')
    let obj = root

    for (i = 0; i < prop.length && obj; i++) {
      obj = obj[prop[i]] ? obj[prop[i]] : false
    }

    if (options && options.fn) {
      obj = obj ? options.fn(obj) : options.inverse(this)
    }

    return obj
  })

  /**
	 * Get all the categories
	 */
  Handlebars.registerHelper('getSeoCategories', categories => {
    const seoCat = []
    let index

    for (index in categories) {
      if (categories.hasOwnProperty(index)) {
        seoCat.push(categories[index].name)
      }
    }

    return seoCat.join('|')
  })

  /**
	 *
	 */
  Handlebars.registerHelper('makeUrl', (action, manager, module) => {
    const components = {}

    if (action) {
      components.action = action
    }

    if (manager) {
      components.manager = manager
    }

    if (module) {
      components.module = module
    }

    return root.makeUrl(components)
  })

  /**
	 *
	 */
  Handlebars.registerHelper('nl2br', string => {
    return new Handlebars.SafeString(root.nl2br(string))
  })

  /**
	 *
	 */
  Handlebars.registerHelper('preloadImage', img => {
    if (_.isString(img)) {
      if (root.IMG_VERSION) {
        img += '?v=' + root.IMG_VERSION
      }

      (new Image()).src = img
    }
  })

  /**
	 *
	 */
  Handlebars.registerHelper('renderPrice', (value, avoidCurrency) => {
    const avoid = _.isBoolean(avoidCurrency) ? avoidCurrency : false

    return new Handlebars.SafeString(root.renderPrice(value, avoid))
  })

  /**
	 *
	 */
  Handlebars.registerHelper('renderSubscriptionDiscount', (priceSell, priceSubscription) => {
    const discountDifference = (priceSubscription * 100) / priceSell
    const discountPercentage = Math.ceil(100 - discountDifference)
    return new Handlebars.SafeString(discountPercentage)
  })

  /**
	 *
	 */
  Handlebars.registerHelper('sortByName', function (values, property, pattern, options) {
    let array; let result; let i

    if (!options) {
      if (pattern) {
        options = pattern
        pattern = null
      } else {
        options = property
        property = null
      }
    }

    array = root.zgSortObjectByProp(values, property, pattern)

    if (array.length) {
      result = ''

      for (i = 0; i < array.length; i++) {
        result += options.fn(array[i], { data: { index: i } })
      }
    } else {
      result = options.inverse(this)
    }

    return result
  })

  /**
	 *
	 */
  Handlebars.registerHelper('split', (value, separator) => {
    return String(value).split(separator || ';')
  })

  /**
	 * Category
	 *
	 * Build the category name to add to the  category url of the blog
	 */
  Handlebars.registerHelper('categoryName', nameReceived => {
    // Replace the empty spaces with underscore
    const name = nameReceived[0].trim().toLowerCase().replace(/\s/g, '_')

    return name
  })

  /**
	 * URL BLOG
	 *
	 * Get the URL of the blog because when we use the alias CMS, we have problems.
	 */
  Handlebars.registerHelper('getBlogUrl', () => {
    return root.ZG_URL_BLOG
  })

  /**
	 * Date
	 * Used in the blog
	 * Build a date like this: Month DD, YYYY
	 */
  Handlebars.registerHelper('dateFormatted', dateReceived => {
    const dateToSplit = dateReceived.split('/')
    const day = dateToSplit[0]
    const month = dateToSplit[1] - 1; const // Convert to JS format from 0 to 11
      year = dateToSplit[2]
    const date = new Date(Date.UTC(year, month, day, 12, 0, 0))
    const options = { month: 'long' }
    const locale = root.SGL_JS_LANG
    const month_translated = date.toLocaleString(locale, options)
    const response = month_translated + ' ' + day + ', ' + year

    return response
  })

  /**
	 *
	 */
  Handlebars.registerHelper('toFixed', (number, fixedTo) => {
    // Only allow integers as parameter
    const fixedDecimals = (typeof fixedTo === 'number' && isFinite(fixedTo) && fixedTo % 1 === 0) ? fixedTo : 2

    if (typeof number === 'string') {
      number = number.replace(/,/g, '')
    }

    return Number(number).toFixed(fixedDecimals)
  })

  /**
	 *
	 */
  Handlebars.registerHelper('translate', translation => {
    return new Handlebars.SafeString(JS_TRANSLATIONS[translation]) || '>>- ' + translation + ' -<<'
  })

  Handlebars.registerHelper('voucherCustomValues', (custom_availables, options) => {
    let result = ''
    for (const custom_available of custom_availables) {
      result += options.fn(custom_available)
    }

    return result
  })

  /**
	 *
	 */
  Handlebars.registerHelper('display_expiry_date', date => {
    const date_format = new Date(date)
    const day = date_format.getDate()
    const month = date_format.getMonth() + 1
    const year = date_format.getFullYear()
    return new Handlebars.SafeString(day + '/' + month + '/' + year)
  })

  /**
   *  Check if there is more than one color in a product
   */
  Handlebars.registerHelper('productCheckMoreThanOneValue', values => {
    return Object.keys(values).length > 1;
  })

  /**
   *  Check if there is a color image or not in product options
   */
  Handlebars.registerHelper('productCheckColorImage', values => {
    let result = true;

    for (const value in values) {
      console.log('values:', values[value]);

      if(!values[value].images || !!values[value].images.color){
        result = false;
        break;
      }
    }

    return result
  });

  Handlebars.registerHelper('getBlogPostAuthor', id => {
    const requestUrl = root.makeUrl({ module: 'eshop', manager: 'eshop', action: 'getContentCMS' })

    $.ajax({
      type: 'GET',
      url: requestUrl,
      dataType: 'json',
      data: {
        contentLinkedToContentId: id
      },
      success: (response) => {
        const data = Object.values(response)[0];

        if(response.length === 0){
          return false;
        }

        for(fatherId of data.aFatherId) {
          document.querySelector(`[data-zg-role="author_container_${fatherId}"]`).classList.remove('d-none');
          const $author_img_container = document.querySelector(`[data-zg-role="author_img_container_${fatherId}"]`);
          const $author_name = document.querySelector(`[data-zg-role="author_name_${fatherId}"]`);
          let authorImgNode = new Image();
          authorImgNode.classList.add("rounded-circle", "img-fluid");

          if ($author_name && data.fields?.name) {
            $author_name.innerHTML = data.fields.name;
          }

          if (data.fields?.image) {
            authorImgNode.src = data.fields.image;
            $author_img_container.innerHTML = '';
            $author_img_container.appendChild(authorImgNode);
            break;
          }
        }
      }
    });
  });

  Handlebars.registerHelper ('priceWithVatIncluded', function ( price,vat ) {
    return price + (price*parseFloat(vat))/100;
  });


  // HANDLEBARS PARTIALS
  // ===================
  handlebarsTemplates.registerPartial('gallery-item');
  handlebarsTemplates.registerPartial('image');
  handlebarsTemplates.registerPartial('product-availability');
  handlebarsTemplates.registerPartial('product-options');
  handlebarsTemplates.registerPartial('product-price');
  handlebarsTemplates.registerPartial('product-shopByLook');
  handlebarsTemplates.registerPartial('product-price-subscription');
  handlebarsTemplates.registerPartial('social-share');
  handlebarsTemplates.registerPartial('storelocator-missing-geolocation-status');
  handlebarsTemplates.registerPartial('blog-post-author');

  // HANDLEBARS AUTOMATIC RENDERING
  // ==============================

  $(() => {
    $('[data-zg-role="render-handlebars"]').each(function () {
      const $this = $(this)
      const data = $this.data()

      $this.html(root.handlebarsTemplates.render(data.template, data.content || {}))
    })
  })
}).call(this, jQuery, _)
